// extracted by mini-css-extract-plugin
export default {"aboutPage":"Q3drh2MxL64dbJ0aZxs2","aboutPageTitle":"YckfCFudWaAN8qs9Hang"};